import { render, staticRenderFns } from "./MedicalSchools.vue?vue&type=template&id=81d3021e&scoped=true"
import script from "./MedicalSchools.vue?vue&type=script&lang=js"
export * from "./MedicalSchools.vue?vue&type=script&lang=js"
import style0 from "./MedicalSchools.vue?vue&type=style&index=0&id=81d3021e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d3021e",
  null
  
)

export default component.exports